<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-2">
    <vs-col>
      <vs-row>
        <headcount-indicator 
        class="cardHeigth" 
        @click="openHeadcount"
        style="font-weight: bold;
              font-size: 1.1em !important;"
              />
      </vs-row>
      <vs-row>
        <direct-indicator 
        class="cardHeigth" 
        @click="openDirect"
        style="font-weight: bold;
              font-size: 1.1em !important;" 
              />
      </vs-row>
      <vs-row>
        <indirect-indicator 
        class="cardHeigth" 
        @click="openIndirect"
        style="font-weight: bold;
              font-size: 1.1em !important;" 
              />
      </vs-row>
      <vs-row>
        <complementary-indicator 
        @click="openComplementary"
        class="cardHeigth"
        style="font-weight: bold;
              font-size: 1.1em !important;" 
              />
      </vs-row>
    </vs-col>
  </div>
</template>

<script>
import HeadcountIndicator from '../charts/HeadcountIndicator.vue'
import DirectIndicator from '../charts/DirectIndicator.vue'
import IndirectIndicator from '../charts/IndirectIndicator.vue'
import ComplementaryIndicator from '../charts/ComplementaryIndicator.vue'

export default {
  components: {
    HeadcountIndicator,
    DirectIndicator,
    IndirectIndicator,
    ComplementaryIndicator,
  },
  data() {
    return {
    }
  },
  props: ['data'],
  methods:{
    openHeadcount(){ 
      this.$emit('click','headcount')
    },
    openDirect(){
      this.$emit('click','direct')
    },
    openIndirect(){
      this.$emit('click','indirect')
    },
    openComplementary(){
      this.$emit('click','complementary')
    }
  }
}
</script>

<style>
.card-value {
  font-size: auto;
  font-weight: bold;
}
.cardHeigth {
  height: 10vh !important;
  margin-bottom: 1vh !important;
}
.letrasNegras {
  color: black;
  font-weight: bold;
  font-size: auto;
}
.colorBoxH {
  padding: 9px;
  border-radius: 6px;
  color: rgb(112, 101, 236);
  background: rgba(112, 101, 236, 0.25);
}
.colorBoxD {
  padding: 9px;
  border-radius: 6px;
  color: rgb(27, 200, 117);
  background: rgba(27, 200, 117, 0.25);
}
.colorBoxI {
  padding: 9px;
  border-radius: 6px;
  color: rgb(255, 159, 74);
  background: rgba(255, 159, 74, 0.25);
}
.colorBoxC {
  padding: 9px;
  border-radius: 6px;
  color: rgb(7, 181, 201);
  background: rgba(7, 181, 201, 0.25);
}
</style>